window.Products.Bag.VeganLeatherToteBag = function() {};
window.Products.Bag.VeganLeatherToteBag.inherits(window.Products.Bag.Bag);